export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 用户列表
    userList: function userList(data) {
      return request({
        url: '/auth/users',
        method: 'get',
        data: data
      });
    },
    // 用户详情
    userDetails: function userDetails(data) {
      return request({
        url: '/user/upUser',
        method: 'get',
        data: data
      });
    },
    // 添加用户
    userAddList: function userAddList(data) {
      return request({
        url: '/user/add',
        method: 'get',
        data: data
      });
    },
    // 添加用户
    userAdd: function userAdd(data) {
      return request({
        url: '/user/add',
        method: 'post',
        data: data
      });
    },
    // 修改用户
    userUpd: function userUpd(data) {
      return request({
        url: '/user/upUser',
        method: 'post',
        data: data
      });
    },
    // 修改用户状态
    disableUser: function disableUser(data) {
      return request({
        url: '/user/disableUser',
        method: 'get',
        data: data
      });
    },
    // 删除用户
    delUser: function delUser(data) {
      return request({
        url: '/user/delUser',
        method: 'get',
        data: data
      });
    },
    // 获取用户的应用权限
    userAppRole: function userAppRole(data) {
      return request({
        url: '/user/userAppRole',
        method: 'get',
        data: data
      });
    },
    // 用户应用权限修改
    userAppRoleUpd: function userAppRoleUpd(data) {
      return request({
        url: '/user/userAppRoleUpd',
        method: 'post',
        data: data
      });
    },
    // 获取用户操作日志
    userOperationLog: function userOperationLog(data) {
      return request({
        url: '/user/operation_log',
        method: 'get',
        data: data
      });
    },
    //获取时间接口
    userOperationLogData: function userOperationLogData(data) {
      return request({
        url: '/user/operation_log_data',
        method: 'get',
        data: data
      });
    },
    //添加教练
    addCoaches: function addCoaches(data) {
      return request({
        url: '/user/addCoaches',
        method: 'post',
        data: data
      });
    },
    //教练列表
    getCoachesList: function getCoachesList(data) {
      return request({
        url: '/user/getCoachesList',
        method: 'post',
        data: data
      });
    },
    //教练修改
    updateCoaches: function updateCoaches(data) {
      return request({
        url: '/user/updateCoaches',
        method: 'post',
        data: data
      });
    },
    //删除教练
    deleteCoaches: function deleteCoaches(data) {
      return request({
        url: '/user/deleteCoaches',
        method: 'post',
        data: data
      });
    }
  };
});